import store from '@/store';

export default class BrokerSuccessEvent {
  constructor(body) {
    // Tratamento criação de lista de transmissão
    const agentId = store.state.attendance.Attendance.agentId;
    if (
      body.eventResponse == 'BroadcastWhatsAppNewListEvent' &&
      agentId == body.agentId
    ) {
      console.log('[AGENT/BROADCAST] - Nova lista criada com sucesso.');
    }
  }
}
